import { render, staticRenderFns } from "./UntitledPaymentCallback.vue?vue&type=template&id=294cecc8&scoped=true&"
import script from "./UntitledPaymentCallback.vue?vue&type=script&lang=ts&"
export * from "./UntitledPaymentCallback.vue?vue&type=script&lang=ts&"
import style0 from "./UntitledPaymentCallback.vue?vue&type=style&index=0&id=294cecc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294cecc8",
  null
  
)

export default component.exports